import {BaseService} from "./BaseService.ts";

export class SubscriptionPlanService {
    static read = (others: any) => {
        return BaseService.apiClient(others).get("/subscription-plan/read");
    };
}

